// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"96":"982b5cd9","281":"06700352","777":"288800e8"}[chunkId] + ".js";
};